const AUDIT_HEADER = 'audit-header'

const BRIEFCASE = `${AUDIT_HEADER}-briefcase`
const DECISIONS = `${AUDIT_HEADER}-decisions`
const ASPECTS = `${AUDIT_HEADER}-aspects`
const DOCUMENTS = `${AUDIT_HEADER}-documents`
const NEWSLETTERS = `${AUDIT_HEADER}-newsletters`
const CHART = `${AUDIT_HEADER}-chart`
const HISTORY = `${AUDIT_HEADER}-history`

const REQUIREMENTS = 'requirements'

const ACTS_REGISTER = `${REQUIREMENTS}-acts-reigster`

const TABLE = 'table'
const ACTS = `${TABLE}-acts`
const OPEN_REQUIREMENT = `${TABLE}-open-requirement`

const REQUIREMENT = 'requirement'
const DOCUMENTS_GROUP = `${REQUIREMENT}-documents-group`
const REQUIREMENT_ASPECTS = `${REQUIREMENT}-aspects`
const REQUIREMENT_DECISIONS = `${REQUIREMENT}-decisions`
const REQUIREMENT_DOCUMENT = `${REQUIREMENT}-document`
const REQUIREMENT_ASSESSMENT = `${REQUIREMENT}-assessment`
const ASSESSMENT_GROUP = `${REQUIREMENT}-assessment-group`
const CLIENT_CLIENT_BASIC_REQUIREMENT_ASPECTS = `${REQUIREMENT}-aspects-client`
const CLIENT_CLIENT_BASIC_REQUIREMENT_DECISIONS = `${REQUIREMENT}-decisions-client`
const CLIENT_CLIENT_BASIC_REQUIREMENT_DOCUMENT = `${REQUIREMENT}-document-client`
const REQUIREMENT_BACK = `${REQUIREMENT}-back`

const ADMINISTRATION = `administration`

const ADMINISTRATION_BUTTON = `${ADMINISTRATION}-button`
const ADD_USER = `${ADMINISTRATION}-add-user`
const ADD_USER_TYPE = `${ADMINISTRATION}-type`
const LOCATIONS = `${ADMINISTRATION}-locations`

const COMPANY_PROFILE = 'company-profile'

const TABS = `${COMPANY_PROFILE}-tabs`
const AUDIT_ICON = `${COMPANY_PROFILE}-audit-icon`

const NEWSLETTERS_PAGE = 'newsletters'

const CHOOSE_SCOPE = `${NEWSLETTERS_PAGE}-choose-scope`

const SELECT_LOCATION = `select-location`
const SELECT_LOCATION_OPEN = `${SELECT_LOCATION}-open`

export default {
  BRIEFCASE,
  DECISIONS,
  ASPECTS,
  DOCUMENTS,
  NEWSLETTERS,
  CHART,
  HISTORY,
  ACTS,
  OPEN_REQUIREMENT,
  DOCUMENTS_GROUP,
  REQUIREMENT_ASPECTS,
  REQUIREMENT_DECISIONS,
  REQUIREMENT_DOCUMENT,
  REQUIREMENT_ASSESSMENT,
  ASSESSMENT_GROUP,
  ADMINISTRATION_BUTTON,
  CLIENT_CLIENT_BASIC_REQUIREMENT_ASPECTS,
  CLIENT_CLIENT_BASIC_REQUIREMENT_DECISIONS,
  CLIENT_CLIENT_BASIC_REQUIREMENT_DOCUMENT,
  REQUIREMENT_BACK,
  ACTS_REGISTER,
  TABS,
  AUDIT_ICON,
  CHOOSE_SCOPE,
  ADD_USER,
  ADD_USER_TYPE,
  SELECT_LOCATION_OPEN,
  LOCATIONS,
}
